// extracted by mini-css-extract-plugin
export default {"styles":"styles___YxRqG","policy":"policy___b_Rf7","header":"header___xrjjo","PolicyFullScreenBtn":"PolicyFullScreenBtn___uYaXy","ModalTile":"ModalTile___ieyzR"};